import { MaterialCommunityIcons } from '@expo/vector-icons';
import { Location } from '@gripp/shared-logic';
import { Platform, Pressable, StyleSheet } from 'react-native';
import openMap from 'react-native-open-maps';
import { Text } from 'react-native-paper';
import { Colors } from '../themes/colors';

type LocationTextProps = {
  location?: Location;
  address?: string;
};

export const LocationText = (props: LocationTextProps) => {
  if (!props.location) return null;

  return (
    <Text style={styles.locationText}>
      <MaterialCommunityIcons name="map-marker" size={12} color="black" />
      {props.address}
      <Pressable
        onPress={() =>
          openMap({
            query: `${props.location?.coordinates[1]}, ${props.location?.coordinates[0]}`,
          })
        }
      >
        <MaterialCommunityIcons
          name="open-in-new"
          color={Colors.primary}
          size={17}
          style={styles.locationButton}
        />
      </Pressable>
    </Text>
  );
};

const styles = StyleSheet.create({
  locationButton: {
    paddingLeft: 5,
    top: 3,
  },
  locationText: {
    ...Platform.select({
      web: {
        fontSize: 12,
        fontWeight: '400',
      },
      default: {
        fontSize: 12,
        fontWeight: '500',
      },
    }),
    color: Colors.role.textStrong,
  },
});
